import { Injectable } from '@angular/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { environment } from '@env/environment';
import { IBusinessCard } from '@interfaces';
@Injectable({
  providedIn: 'root',
})
export class SeoService {
  constructor(
    private meta: Meta,
    private title: Title,
  ) {}

  setMetaTitles(businessCardDetails: IBusinessCard) {
    const metaForFB: MetaDefinition[] = [
      {
        property: 'og:type',
        content: 'website',
      },
      {
        property: 'og:url',
        content: businessCardDetails.cardUrl,
      },
      {
        property: 'og:title',
        content: businessCardDetails.company,
      },
      {
        property: 'og:description',
        content: businessCardDetails.businessDescription,
      },
      {
        property: 'og:image',
        content: businessCardDetails.logo
          ? environment.imageUrl + businessCardDetails.logo
          : 'https://nirlat-assets.s3.il-central-1.amazonaws.com/stage/assets/public/nirlat_144x144.png',
      },
      {
        name: 'twitter:card',
        content: businessCardDetails.logo
          ? environment.imageUrl + businessCardDetails.logo
          : 'https://nirlat-assets.s3.il-central-1.amazonaws.com/stage/assets/public/nirlat_144x144.png',
      },
      {
        name: 'twitter:url',
        content: businessCardDetails.cardUrl,
      },
      {
        name: 'twitter:title',
        content: businessCardDetails.company,
      },
      {
        name: 'twitter:description',
        content: businessCardDetails.businessDescription,
      },
      {
        name: 'twitter:image',
        content: businessCardDetails.logo
          ? environment.imageUrl + businessCardDetails.logo
          : 'https://nirlat-assets.s3.il-central-1.amazonaws.com/stage/assets/public/nirlat_144x144.png',
      },
    ];

    this.title.setTitle(businessCardDetails.company);
    this.addMetaTags(metaForFB);
  }

  addMetaTags(tags: MetaDefinition[]) {
    this.meta.addTags(tags);
  }
}
